import { render } from "./StepServicesForm.vue?vue&type=template&id=6b8c0031"
import script from "./StepServicesForm.vue?vue&type=script&lang=js"
export * from "./StepServicesForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__